'use strict';
import * as $j_app$002edata$002e$002dUser$002dDetails$0024$0024anon$00241 from "./app.data.-User-Details$$anon$1.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$0024 from "./app.data.-User-Details$package$-User-First-Name$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$0024 from "./app.data.-User-Details$package$-User-Last-Name$.js";
import * as $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$0024 from "./app.data.-User-Details$package$-User-Middle-Name$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserDetails(firstName, middleName, lastName) {
  this.z4 = null;
  this.z6 = null;
  this.z5 = null;
  this.aG2 = null;
  this.aG3 = false;
  this.z4 = firstName;
  this.z6 = middleName;
  this.z5 = lastName;
}
export { $c_Lapp_data_UserDetails as $c_Lapp_data_UserDetails };
$p = $c_Lapp_data_UserDetails.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_UserDetails;
/** @constructor */
function $h_Lapp_data_UserDetails() {
}
export { $h_Lapp_data_UserDetails as $h_Lapp_data_UserDetails };
$h_Lapp_data_UserDetails.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_UserDetails) && (((this.z4 === x$0.z4) && (this.z6 === x$0.z6)) && (this.z5 === x$0.z5))));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 3;
});
$p.t = (function() {
  return "UserDetails";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.z4;
      break;
    }
    case 1: {
      return this.z6;
      break;
    }
    case 2: {
      return this.z5;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "firstName";
      break;
    }
    case 1: {
      return "middleName";
      break;
    }
    case 2: {
      return "lastName";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.a4X = (function() {
  if ((!this.aG3)) {
    var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
    var this$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$ToShowOps$$anon$3(this.z4, $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dFirst$002dName$0024.$m_Lapp_data_UserDetails$package$UserFirstName$().aA());
    var $x_2 = this$3.bq.aT(this$3.bp);
    var this$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$ToShowOps$$anon$3(this.z6, $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dMiddle$002dName$0024.$m_Lapp_data_UserDetails$package$UserMiddleName$().aA());
    var $x_1 = this$6.bq.aT(this$6.bp);
    var this$9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_Show$ToShowOps$$anon$3(this.z5, $j_app$002edata$002e$002dUser$002dDetails$0024package$0024$002dUser$002dLast$002dName$0024.$m_Lapp_data_UserDetails$package$UserLastName$().aA());
    var this$11 = $x_4.aO($x_3.d(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.r().C)([$x_2, $x_1, this$9.bq.aT(this$9.bp)])));
    $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
    var b = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sci_VectorBuilder();
    var it = this$11.r();
    while (it.l()) {
      b.oy($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_exts_StringExts$package$().bY6($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__trim__T(it.k())));
    }
    this.aG2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T(b.hP(), "", " ", "");
    this.aG3 = true;
  }
  return this.aG2;
});
$p.bXP = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  return new $j_app$002edata$002e$002dUser$002dDetails$0024$0024anon$00241.$c_Lapp_data_UserDetails$$anon$1().bwS(this);
});
function $isArrayOf_Lapp_data_UserDetails(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jY)));
}
export { $isArrayOf_Lapp_data_UserDetails as $isArrayOf_Lapp_data_UserDetails };
var $d_Lapp_data_UserDetails = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserDetails, "app.data.UserDetails", ({
  jY: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_UserDetails as $d_Lapp_data_UserDetails };
//# sourceMappingURL=app.data.-User-Details.js.map
